var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { EventEmitter, OnInit } from '@angular/core';
import { ActivityService } from 'app/services/activity.service';
import { FlipRoadService } from 'app/services/flip-road.service';
import { MainDataService } from 'app/services/main-data.service';
var RcRoadDirectionComponent = /** @class */ (function () {
    function RcRoadDirectionComponent(activityService, flipRoadService, mainDataService) {
        this.activityService = activityService;
        this.flipRoadService = flipRoadService;
        this.mainDataService = mainDataService;
        // isFromLeftError;
        // isToLeftError;
        // isFromRightError;
        // isToRightError;
        this.edit = new EventEmitter();
        this.jointChange = new EventEmitter();
        this.attach = new EventEmitter();
        this.flipFromTo = new EventEmitter();
    }
    RcRoadDirectionComponent.prototype.onEdit = function (e) {
        this.edit.emit(e);
    };
    RcRoadDirectionComponent.prototype.clickJointChange = function (side) {
        this.jointChange.emit({
            side: side,
            idx: this.centerlineIdx
        });
    };
    RcRoadDirectionComponent.prototype.clickAttach = function (side) {
        this.attach.emit({
            side: side,
            id: this.centerline.id
        });
    };
    RcRoadDirectionComponent.prototype.clickFlipFromTo = function (side) {
        this.flipFromTo.emit({
            side: side,
            id: this.centerline.id
        });
    };
    RcRoadDirectionComponent.prototype.flipRoadAttrs = function () {
        return __awaiter(this, void 0, void 0, function () {
            var rsp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.flipRoadService.flipRoadAttrs(this.centerline.props)];
                    case 1:
                        rsp = _a.sent();
                        if (rsp && !rsp.cancel && rsp.cols && rsp.cols.length) {
                            this.flipRoadService.flipRoadSubject.next({
                                id: this.centerline.id,
                                transposeCols: rsp.cols
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    RcRoadDirectionComponent.prototype.flipRoadGeom = function () {
        this.flipRoadService.flipRoadSubject.next({
            id: this.centerline.id,
            geom: true
        });
    };
    RcRoadDirectionComponent.prototype.calcAttrFlipIconPosition = function () {
        // Two lines' relavtive position is horizontal (two line in same row)
        if (this.centerline.relativePosition === 'left' || this.centerline.relativePosition === 'right') {
            // The line itself is horizontal
            if (this.centerline.horizontalVertical === 'hori') {
                this.attrFlipIconPosition = this.centerlineIdx === 0 ? 'left' : 'right';
            }
            // The line itself is vertical
            else {
                this.attrFlipIconPosition = this.centerline.direction === 'N' ? 'upper' : 'lower';
            }
        }
        // Two lines in same column
        else {
            // The line itself is vertical
            if (this.centerline.horizontalVertical === 'vert') {
                this.attrFlipIconPosition = this.centerlineIdx === 0 ? 'upper' : 'lower';
            }
            // The line itself is horizontal
            else {
                this.attrFlipIconPosition = this.centerline.direction === 'W' ? 'left' : 'right';
            }
        }
    };
    RcRoadDirectionComponent.prototype.ngOnInit = function () {
        // Calculate attrFlipIcon position
        this.calcAttrFlipIconPosition();
    };
    return RcRoadDirectionComponent;
}());
export { RcRoadDirectionComponent };
